import { createContext } from "react";
import { GetPathItems, Route } from "routes";

export interface UpdateRoute {
	params?: GetPathItems;
	name?: string;
}

export interface UseBreadcrumbsPayload {
	breadcrumbs: Route[];

	/**
	 * Update the last breadcrumbs.
	 *
	 * If `delta` is a `string`, then the last breadcrumb's name is updated.
	 *
	 * If `delta` is an array of `n` items, then the last `n` items will be
	 * updated. If an item is `undefined` or an empty object, no change is made
	 * to the breadcrumb.
	 */
	updateLastBreadcrumbs: (
		delta: string | UpdateRoute | Array<UpdateRoute | string | undefined>,
	) => void;
}

export const BreadcrumbsContext = createContext<UseBreadcrumbsPayload | null>(
	null,
);
